import React, { useEffect } from "react";
import { Alert, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { useConselhosState } from "../context/conselhos-context";
import { useConselhosController } from "../context/conselhos-controller";
import { TextInputWithCounter } from "../../../components/text-input-with-counter";
import PlainTextArea from "../../../components/plain-text-area";
import { ConselhoMembrosSection } from "./conselho-membros-section";
import { ConselhoAtasSection } from "./conselho-atas-section";

export const ConselhoForm = () => {
    const { dataRequest, areasList } = useConselhosState();
    const { handleOnChangeForm, loadLookups } = useConselhosController();
    const isExistingRecord = dataRequest?.id !== undefined && dataRequest?.id !== null;

    useEffect(() => {
        (async () => {
            await loadLookups();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item lg={6} sm={6} xl={6}>
                    <InputLabel>Área *</InputLabel>
                    <Select
                        size="small"
                        error={!dataRequest?.idAreaTransparenciaSetorial}
                        value={dataRequest?.idAreaTransparenciaSetorial ?? ''}
                        onChange={(e) => handleOnChangeForm('idAreaTransparenciaSetorial', e.target.value)}
                        fullWidth
                    >
                        <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                        {areasList?.slice().sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')).map((a) => <MenuItem value={a.id} key={a.id}>{a.name}</MenuItem>)}
                    </Select>
                </Grid>

                <Grid item lg={6} sm={6} xl={6}>
                    <InputLabel>Nome do Conselho *</InputLabel>
                    <TextInputWithCounter
                        size="small"
                        maxLength={150}
                        error={!dataRequest?.nomeConselho}
                        value={dataRequest?.nomeConselho || ''}
                        onChange={(e) => handleOnChangeForm('nomeConselho', e.target.value)}
                        fullWidth
                    />
                </Grid>

                <Grid item lg={12} sm={12} xl={12}>
                    <InputLabel>Norma de Criação (lei/decreto)</InputLabel>
                    <PlainTextArea
                        size="small"
                        rows={2}
                        value={dataRequest?.textoNormaCriacao || ''}
                        onChange={(e: any) => handleOnChangeForm('textoNormaCriacao', e.target.value)}
                        fullWidth
                    />
                </Grid>

                {isExistingRecord ? (
                    <>
                        <ConselhoMembrosSection />
                        <ConselhoAtasSection />
                    </>
                ) : (
                    <Grid item lg={12} sm={12} xl={12}>
                        <Alert severity="info">
                            Salve o conselho primeiro para liberar o cadastro de Membros e Atas.
                        </Alert>
                    </Grid>
                )}
            </Grid>
        </React.Fragment>
    );
};
